export default "__VITE_ASSET__DSLd0Q0M__"